import { isString } from 'lodash/fp'
import { ErrorT } from './getErrorMsg'
import { type ServerApiError } from '@wellesley/openapi/helpers'

export const getServerApiErrorCode = (error?: ErrorT) => {
  if (!error) return null
  if (isString(error)) return null
  if ('data' in error && (error.data as ServerApiError)?.errorCode)
    return (error.data as ServerApiError)?.errorCode
  if (
    'error' in error &&
    typeof error.error === 'object' &&
    error.error !== null
  ) {
    const errorObj = error.error as { data?: { errorCode?: string } }
    if (errorObj.data?.errorCode) return errorObj.data.errorCode
  }
  return null
}
